import React from 'react';

import PropTypes from 'prop-types';

import { Container, Inner } from './styles';

export const LightFixedBottomPanel = (props) => {
    return (
        <Container pressedAboveCookieButton={props.pressedAboveCookieButton}>
            <Inner pressedAboveCookieButton={props.pressedAboveCookieButton}>{props.children}</Inner>
        </Container>
    );
};

LightFixedBottomPanel.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
    pressedAboveCookieButton: PropTypes.bool,
};
